import React from 'react'
import SpinnerSvg from 'images/modules/Manage/i-spinner.svg?raw'

export { default as SpinnerUrl } from 'images/modules/Manage/i-spinner.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: SpinnerSvg}} />
)
